// removed by extract-text-webpack-plugin
module.exports = {"messageText":"qempo_IphoneQempoFullWarning_messageText-1R2Dv2j"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/ProductStep/components/IphoneQempoFullWarning/IphoneQempoFullWarning.scss
// module id = 1666
// module chunks = 0